module.exports = __webpack_public_path__ + "static/media/value-prop-icon-3.2e246b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value-prop-icon-3.svg
// module id = 1412
// module chunks = 0